<template>
  <v-container
    fluid
    class="pt-0"
  >
    <label class="title">
      Transformações e Mapa de Campo
    </label>
    <v-data-table
      class="default-table-height elevation-1 transformationDataTable"
      :headers="columnHeadersComputed"
      :items="mainColumns"
      :single-expand="true"
      :items-per-page="-1"
      item-key="order"
      :show-group-by="isImport"
      show-expand
      hide-default-footer
      fixed-header
      hide-default-header
      :height="mainColumnsLength > 10 ? 550 : null"
    >
      <template v-slot:no-data>
        <span>Não há colunas convencionais</span>
      </template>
      <template v-slot:header="{ props }">
        <thead class="v-data-table-header">
          <tr class="table-header">
            <th
              class="backgroundHeaderTransformation"
              v-for="header in props.headers"
              :key="header.text"
            >
              <label class="label primary--text">
                {{ header.text }}
              </label>
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:[`item.order`]="{ item: column }">
        <v-container
          fluid
        >
          <v-row
            no-gutters
          >
            <v-col cols="3" style="width: 20px; max-width: 20px;"/>

            <v-col
              cols="6"
              class="d-flex justify-center"
              style="width: 50px; max-width: 50px;"
            >
              <span
                class="d-flex align-center"
                style="height: 24px;"
              >
                {{ column.order }}
              </span>
            </v-col>

            <v-col style="width: 20px; max-width: 20px;" />
          </v-row>
        </v-container>
      </template>
      <template v-slot:[`item.fromTo`]="{ item }">
        <v-row
          justify="center"
          class="my-0"
        >
          <v-col
            cols="12"
            lg="9"
            class="py-0 my-0"
          >
            <div
              v-if="isImport && layout.typeIntegrationValue === 'SHIPPING'"
              class="d-flex flex-row justify-space-between mt-6"
            >
              <div class="d-flex flex-column align-start">
                <v-autocomplete
                  v-model="item.idDataSource"
                  @change="changeIdDataSource(item)"
                  :items="dataSourceFonts"
                  item-text="label"
                  item-value="id"
                  placeholder="Fonte"
                  class="mr-2"
                  color="primary"
                  dense
                  solo
                  :rules="[rule.required]"
                  style="max-width: 210px"
                  validate-on-blur
                >
                  <template v-slot:prepend>
                    <v-tooltip
                      bottom
                      color="primary"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi mdi-information-outline
                        </v-icon>
                      </template>

                      <span>
                        Campo utilizado para definir a fonte das colunas
                        configuradas.
                      </span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </div>
              <v-autocomplete
                v-model="item.fromTo"
                :items="item.dataSources"
                :disabled="!item.idDataSource"
                item-text="label"
                item-value="value"
                placeholder="Informe"
                class=""
                color="primary"
                dense
                solo
                :rules="[rule.required]"
                validate-on-blur
              />
            </div>
            <v-text-field
              v-if="isImportForReceivementOrPayroll"
              v-model="item.name"
              placeholder="Informe"
              class="mt-6"
              color="primary"
              dense
              solo
              readonly
            />
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <v-row
          v-if="isImport"
          justify="center"
          class="my-0"
        >
          <v-col
            cols="12"
            lg="9"
            align="center"
            class="py-0 my-0"
          >
            <v-autocomplete
              v-if="isImportForReceivementOrPayroll"
              v-model="item.fromTo"
              :items="propsFromToFields"
              item-text="label"
              item-value="value"
              placeholder="Informe"
              class="mt-6"
              color="primary"
              dense
              solo
              :rules="[rule.required]"
              validate-on-blur
            />
            <v-text-field
              v-if="isImport && layout.typeIntegrationValue === 'SHIPPING'"
              v-model="item.name"
              placeholder="Informe"
              class="mt-6"
              color="primary"
              dense
              solo
              readonly
            />
          </v-col>
        </v-row>
        <span>{{ !isImport ? item.name : null }}</span>
      </template>
      <template v-slot:[`item.type`]="{ item }">
        <span>
          {{ setColumnType(item.type) }}
        </span>
      </template>
      <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
        <TransformationIcon
          :column="item"
          :isExpanded="isExpanded"
          @click="expand(!isExpanded)"
        />
      </template>
      <template v-slot:expanded-item="{ item }">
        <td
          :colspan="columnHeaders.length"
          class="mx-0 px-0"
        >
          <v-row class="pa-0 ma-0">
            <v-col
              class="px-0 py-0"
              cols="12"
            >
              <v-data-table
                class="elevation-1 px-0 pb-1"
                :headers="transformationHeaders"
                :items="item.transformations"
                :items-per-page="-1"
                loading-text="Carregando..."
                dense
                hide-default-footer
              >
                <template v-slot:no-data>
                  <span>
                    Não há transformações
                  </span>
                </template>
                <template v-slot:[`item.isChecked`]="{ item: itemChild }">
                  <td
                    :class="{
                      isSelectedTransformation: itemChild.isChecked,
                    }"
                  >
                    <v-row class="justify-center">
                      <v-checkbox
                        color="primary"
                        v-model="itemChild.isChecked"
                        :disabled="onDisableIsChecked(item, itemChild)"
                        @change="onChangeIsChecked(item, itemChild)"
                        @click="onClickIsChecked(item, itemChild)"
                      />
                    </v-row>
                  </td>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <td
                    align="center"
                    :class="{
                      'isSelectedTransformation font-weight-bold':
                        item.isChecked,
                      'text-center': true,
                    }"
                  >
                    {{ item.name }}
                  </td>
                </template>
                <template v-slot:[`item.actions`]="{ item: itemChild }">
                  <td
                    align="center"
                    :class="{
                      isSelectedTransformation: itemChild.isChecked,
                      'text-center': true,
                    }"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="itemChild.isModal"
                          :disabled="itemChild.isChecked ? false : true"
                          @click="openModalTransformations(itemChild, item)"
                          v-bind="attrs"
                          v-on="on"
                          icon
                          color="primary"
                        >
                          <v-icon color="primary">
                            mdi-square-edit-outline
                          </v-icon>
                        </v-btn>
                      </template>
                    </v-menu>
                  </td>
                </template>
                <template v-slot:[`item.order`]="{ item: itemChild }">
                  <td
                    align="center"
                    :class="{
                      isSelectedTransformation: itemChild.isChecked,
                      'text-center': true,
                    }"
                  >
                    <v-row>
                      <v-text-field
                        v-if="itemChild.isChecked"
                        placeholder="Informe"
                        class="mt-6 pr-4"
                        color="primary"
                        v-model="itemChild.order"
                        v-mask="'####'"
                        dense
                        solo
                        autofocus
                        :disabled="onDisabledChildIsChecked(itemChild)"
                        :rules="onRulesIsChecked(item, itemChild)"
                      >
                        <template v-slot:prepend>
                          <v-tooltip
                            v-if="
                              itemChild.isChecked &&
                              itemChild.template === 'concatenar_campos'
                            "
                            bottom
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                            </template>
                            Por padrão, está função sempre será executada
                            primeiro.
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-row>
                  </td>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
    <v-row
      no-gutters
      class="mt-13 mb-2"
      v-if="layout.typeIntegrationValue === 'RECEIVEMENT'"
    >
      <v-col>
        <label
          class="title"
        >
          Colunas Complementares
        </label>
      </v-col>
    </v-row>
    <v-data-table
      v-if="layout.typeIntegrationValue === 'RECEIVEMENT'"
      class="default-table-height elevation-1"
      :headers="columnComplementaryHeadersComputed"
      :items="complementaryColumns"
      :single-expand="true"
      :items-per-page="-1"
      item-key="order"
      :show-group-by="isImport"
      show-expand
      hide-default-footer
      fixed-header
      hide-default-header
      :height="complementaryColumnsLength > 10 ? 550 : null"
    >
      <template v-slot:no-data>
        <span>Não há colunas complementares</span>
      </template>
      <template v-slot:header="{ props }">
        <thead class="v-data-table-header">
          <tr class="table-header">
            <th
              class="backgroundHeaderTransformation"
              v-for="header in props.headers"
              :key="header.text"
            >
              <label class="label primary--text">
                {{ header.text }}
              </label>
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:[`item.order`]="{ item: column }">
        <v-container
          fluid
        >
          <v-row
            no-gutters
          >
            <v-col cols="3" style="width: 20px; max-width: 20px;"/>

            <v-col
              cols="6"
              class="d-flex justify-center"
              style="width: 50px; max-width: 50px;"
            >
              <span
                class="d-flex align-center"
                style="height: 24px;"
              >
                {{ column.order }}
              </span>
            </v-col>

            <v-col
              cols="3"
              style="width: 20px; max-width: 20px;"
            >
              <HintIcon
                v-if="setTransformationColumnInfo(column) !== false"
                :info="setTransformationColumnInfo(column)"
                :icon="setColumnIcon(column)"
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:[`item.fromTo`]="{ item }">
        <v-row
          justify="center"
          class="my-0"
        >
          <v-col
            cols="12"
            lg="9"
            class="py-0 my-0"
          >
            <v-autocomplete
              v-model="item.name"
              :items="layoutColumns"
              item-text="label"
              item-value="value"
              placeholder="Informe"
              class="mt-6"
              color="primary"
              dense
              solo
              :rules="[rule.required]"
              validate-on-blur
            />
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <v-row
          v-if="isImport"
          justify="center"
          class="my-0"
        >
          <v-col
            cols="12"
            lg="9"
            align="center"
            class="py-0 my-0"
          >
            <v-autocomplete
              v-model="item.fromTo"
              :items="fromToFields"
              item-text="label"
              item-value="value"
              placeholder="Informe"
              class="mt-6"
              color="primary"
              dense
              solo
              :rules="[rule.required]"
              validate-on-blur
            />
          </v-col>
        </v-row>
        <span>
          {{ !isImport ? item.name : null }}
        </span>
      </template>
      <template v-slot:[`item.type`]="{ item }">
        <span>
          {{ setColumnType(item.type) }}
        </span>
      </template>
      <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
        <TransformationIcon
          :column="item"
          :isExpanded="isExpanded"
          @click="expand(!isExpanded)"
        />
      </template>
      <template v-slot:expanded-item="{ item }">
        <td
          :colspan="columnComplementaryHeaders.length"
          class="mx-0 px-0"
        >
          <v-row class="pa-0 ma-0">
            <v-col
              class="px-0 py-0"
              cols="12"
            >
              <v-data-table
                class="elevation-1 px-0 pb-1"
                :headers="transformationHeaders"
                :items="item.transformations"
                :items-per-page="-1"
                loading-text="Carregando..."
                dense
                hide-default-footer
              >
                <template v-slot:no-data>
                  <span>Não há transformações</span>
                </template>
                <template v-slot:[`item.isChecked`]="{ item: itemChild }">
                  <td
                    :class="{
                      isSelectedTransformation: itemChild.isChecked,
                    }"
                  >
                    <v-row class="justify-center">
                      <v-checkbox
                        color="primary"
                        v-model="itemChild.isChecked"
                        :disabled="onDisableIsChecked(item, itemChild)"
                        @change="onChangeIsChecked(item, itemChild)"
                        @click="onClickIsChecked(item, itemChild)"
                      />
                    </v-row>
                  </td>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <td
                    align="center"
                    :class="{
                      'isSelectedTransformation font-weight-bold':
                        item.isChecked,
                      'text-center': true,
                    }"
                  >
                    {{ item.name }}
                  </td>
                </template>
                <template v-slot:[`item.actions`]="{ item: itemChild }">
                  <td
                    align="center"
                    :class="{
                      isSelectedTransformation: itemChild.isChecked,
                      'text-center': true,
                    }"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="itemChild.isModal"
                          :disabled="itemChild.isChecked ? false : true"
                          @click="openModalTransformations(itemChild, item)"
                          v-bind="attrs"
                          v-on="on"
                          icon
                          color="primary"
                        >
                          <v-icon color="primary">
                            mdi-square-edit-outline
                          </v-icon>
                        </v-btn>
                      </template>
                    </v-menu>
                  </td>
                </template>
                <template v-slot:[`item.order`]="{ item: itemChild }">
                  <td
                    align="center"
                    :class="{
                      isSelectedTransformation: itemChild.isChecked,
                      'text-center': true,
                    }"
                  >
                    <v-row>
                      <v-text-field
                        v-if="itemChild.isChecked"
                        placeholder="Informe"
                        class="mt-6 pr-4"
                        color="primary"
                        v-model="itemChild.order"
                        v-mask="'####'"
                        dense
                        solo
                        autofocus
                        :disabled="onDisabledChildIsChecked(itemChild)"
                        :rules="onRulesIsChecked(item, itemChild)"
                      >
                        <template v-slot:prepend>
                          <v-tooltip
                            v-if="
                              itemChild.isChecked &&
                              itemChild.template === 'concatenar_campos'
                            "
                            bottom
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                            </template>
                            Por padrão, está função sempre será executada
                            primeiro.
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-row>
                  </td>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>

    <Transformations
      ref="transformationModal"
      :propsTransformationParameter="transformationParameter"
      @on-confirm="addColumnFunctionFromModal"
    />
    <TransformationsFromTo
      ref="transformationsFromToModal"
      :propsTransformationParameter="transformationParameter"
      @on-confirm="addColumnFunctionFromModal"
    />
    <TransformationsFromToAdvanced
      ref="transformationsFromToAdvancedModal"
      :propsTransformationParameter="transformationParameter"
      :layout="layout"
      :dataSourceColumns="propsFromToFields"
      @on-confirm="addColumnFunctionFromModal"
    />

    <TransformationsConcatColumnModal
      ref="transformationsConcatColumnModal"
      :propsTransformationParameter="transformationParameter"
      :layout="layout"
      :dataSourceColumns="propsFromToFields"
      @on-confirm="addColumnFunctionFromModal"
    />

    <SnackbarCustomize ref="SnackbarCustomize" />
  </v-container>
</template>

<script>
import Rules from '@/shared/validators/formRules';
import Transformations from '@/components/Layout/Transformations/Modals/transformationsModal.vue';
import TransformationsFromTo from '@/components/Layout/Transformations/Modals/transformationsFromToModal.vue';
import TransformationsFromToAdvanced from '@/components/Layout/Transformations/Modals/transformationsFromToAdvancedModal.vue';
import TransformationsConcatColumnModal from '@/components/Layout/Transformations/Modals/transformationsConcatColumnModal.vue';
import lodash from 'lodash';
import FunctionService from '@/services-http/sdi/FunctionService';
import DataSourceService from '@/services-http/sdi/DataSourceService';
import { observableMutationsRefreshToken } from '@/shared/observable/loadingRefreshToken';
import AuthService from '@/services-http/auth/AuthService';
import UserService from '@/services-http/security/UserService';
import UserUtils from '@/shared/utils/user-utils';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import { mapGetters } from 'vuex';
import Formatters from '@/shared/formatters/formatters';
import HintIcon from '@/components/HintIcon/HintIcon.vue';
import LayoutImportMixin from '@/shared/mixins/layoutImport/layoutImportMixin';
import { hasEffectiveBearerToken } from '@/services/auth-strategy';
import TransformationIcon from './TransformationIcon.vue';

export default {
  components: {
    Transformations,
    TransformationsFromTo,
    TransformationsFromToAdvanced,
    TransformationsConcatColumnModal,
    SnackbarCustomize,
    TransformationIcon,
    HintIcon,
  },

  data: () => ({
    layout: {},
    formatter: null,
    transformationParameter: {},
    isVisualization: false,
    snackbar: {
      type: '',
      show: false,
      text: '',
    },
    types: [
      {
        value: 'ALPHANUMERIC',
        text: 'Alfanumérico',
      },
      {
        value: 'NUMERIC',
        text: 'Numérico',
      },
      {
        value: 'DATE',
        text: 'Data',
      },
    ],
    transformationFunctions: [],
    columnHeaders: [
      {
        text: 'Campo',
        value: 'order',
        align: 'center',
        sortable: false,
      },
      {
        text: '"DE"',
        value: 'fromTo',
        align: 'center',
        sortable: false,
      },
      {
        text: '"PARA"',
        value: 'name',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Nome',
        value: 'name',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Tipo',
        value: 'type',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Transformações',
        value: 'data-table-expand',
        align: 'center',
        sortable: false,
      },
    ],
    transformationHeaders: [
      {
        text: 'Selecionar',
        value: 'isChecked',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Nome',
        value: 'name',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'actions',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Ordem',
        value: 'order',
        align: 'center',
        sortable: false,
        width: '15%',
      },
    ],
    columnComplementaryHeaders: [
      {
        text: 'Campo',
        value: 'order',
        align: 'center',
        sortable: false,
      },
      {
        text: '"DE"',
        value: 'fromTo',
        align: 'center',
        sortable: false,
      },
      {
        text: '"PARA"',
        value: 'name',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Nome',
        value: 'name',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Tipo',
        value: 'type',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Transformações',
        value: 'data-table-expand',
        align: 'center',
        sortable: false,
      },
    ],

    SESSION_STORAGE_TOKEN: '@auth/token',
    SESSION_ODOO_TOKEN: '@auth-odoo/token',
  }),

  props: {
    propsLayout: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: true,
    },
    isCopy: {
      type: Boolean,
      required: true,
    },
    isImport: {
      type: Boolean,
      required: true,
    },
    dataSourceColumns: Array,
    propsFromToFields: Array,
  },

  mixins: [
    LayoutImportMixin,
  ],

  watch: {
    propsLayout: {
      handler(val) {
        if (val) {
          this.layout = val;
          this.loadTransformationFunctions();
          this.setColumnsDataSources();
        }
      },
    },
    dataSourceColumns: {
      handler(val) {
        if (val) {
          this.setColumnsDataSources();
        }
      },
    },
  },

  mounted() {
    if (sessionStorage.getItem('visualization')) {
      this.isVisualization = true;
    }
  },

  computed: {
    ...mapGetters({
      layoutData: 'layout-import/layout',
      dataSourceFonts: 'layout-import/dataSourceFonts',
    }),
    isImportForReceivementOrPayroll() {
      return (
        this.isImport &&
        (
          this.layout.typeIntegrationValue === 'RECEIVEMENT' ||
          this.layout.typeIntegrationValue === 'PAYROLL'
        )
      )
    },
    layoutColumns() {
      const columns = [...this.layout.columns];
      const dataColumns = [];
      columns.forEach((column) => {
        if (column.name) {
          dataColumns.push({
            label: column.name,
            value: column.name,
          });
        }
      });
      if (this.layout.typeIntegrationValue === 'RECEIVEMENT') {
        if (
          !dataColumns.some((column) => column.label === 'Sem Referência')
        ) {
          dataColumns.push({
            label: 'Sem Referência',
            value: 'Sem Referência',
          });
        }
      } else if (
        !dataColumns.some((column) => column.label === 'no_reference')
      ) {
        dataColumns.push({
          label: 'Sem Referência',
          value: 'no_reference',
        });
      }
      return dataColumns;
    },
    fromToFields() {
      return this.propsFromToFields.filter(
        (column) => column && column.label.toLowerCase() !== 'sem referência'
      );
    },
    complementaryColumns() {
      if (
        this.layout &&
        this.layout.columns &&
        this.layout.columns.length > 0
      ) {
        const columns = [...this.layout.columns].sort((a, b) =>
          a.order > b.order ? 1 : -1
        );
        return columns.filter(
          (column) =>
            column.complementaryLayout === true
            && column.columnType === 'DEFAULT'
        );
      }
      return [];
    },
    complementaryColumnsLength() {
      return this.complementaryColumns.length;
    },
    columnHeadersComputed() {
      if (this.isImport) {
        return this.columnHeaders.filter(
          (element) => element.text !== 'Nome'
        );
      }
      return this.columnHeaders.filter(
        (element) => element.value !== 'fromTo' && element.text !== '"PARA"'
      );
    },
    columnComplementaryHeadersComputed() {
      if (this.isImport) {
        return this.columnComplementaryHeaders.filter(
          (element) => element.text !== 'Nome'
        );
      }
      return this.columnComplementaryHeaders.filter(
        (element) => element.value !== 'fromTo' && element.text !== '"PARA"'
      );
    },
    mainColumns() {
      if (
        this.layout &&
        this.layout.columns &&
        this.layout.columns.length > 0
      ) {
        return this.layout.columns.filter(
          (column) =>
            column.complementaryLayout !== true
            && column.columnType === 'DEFAULT'
        );
      }
      return [];
    },
    mainColumnsLength() {
      return this.mainColumns.length;
    },
  },

  methods: {
    onChangeIsChecked(item, itemChild) {
      this.isValidOrder = this.rule.checkRepeatOrders(
        itemChild.order,
        item.transformations
      );

      this.$forceUpdate();
    },
    onClickIsChecked(item, itemChild) {
      if (itemChild.isModal && itemChild.isChecked) {
        this.openModalTransformations(itemChild, item);
        return;
      }

      if (!itemChild.isModal && itemChild.isChecked) {
        this.checkParameterInTransformation(itemChild, item);

        return;
      }

      itemChild.order = '';
    },
    onDisableIsChecked(item, itemChild) {
      return (
        this.isVisualization ||
        this.isToDisableCheck(itemChild, item) ||
        this.concatFunctionValidationBtn(itemChild)
      );
    },
    onDisabledChildIsChecked(itemChild) {
      return (
        this.isVisualization ||
        (
          itemChild.isChecked &&
          itemChild.template === 'concatenar_campos'
        )
      )
    },
    onRulesIsChecked(item, itemChild) {
      return [
        this.rule.required,
        this.rule.checkRepeatOrders(
          itemChild.order,
          item.transformations
        ),
      ]
    },
    setColumnType(columnType) {
      switch (columnType) {
        case 'ALPHANUMERIC':
          return 'Alfanumérico';

        case 'NUMERIC':
          return 'Numérico';

        case 'DATE':
          return 'Data';
      }
    },
    changeIdDataSource(column) {
      column.fromTo = null;

      column.dataSources = [];

      this.loadColumnDataSources(column);

      this.$forceUpdate();
    },
    setColumnsDataSources() {
      if (!this.layout) return;
      if (!this.dataSourceColumns || this.dataSourceColumns.length === 0)
        return;

      this.layout.columns.forEach((column) => {
        this.loadColumnDataSources(column);
      });
    },
    loadColumnDataSources(item) {
      const dataSource = this.dataSourceColumns.find(
        (font) => font.id === item.idDataSource
      );

      item.dataSources = !!dataSource ? dataSource.columns : [];
    },
    async loadTransformationFunctions() {
      try {
        const response = await this.functionService.FindAll();

        if (response && response.data) {
          this.transformationFunctions = response.data;

          const deParaTransformation = this.transformationFunctions.find(
            (element) => element.id === 'depara'
          );
          deParaTransformation.parameters = [
            { isField: false, name: 'Campo', order: 1 },
          ];

          const deParaAdvancedTransformation =
            this.transformationFunctions.find(
              (element) => element.id === 'depara_avancado'
            );
          deParaAdvancedTransformation.parameters = [];

          const concatColumnTransformation =
            this.transformationFunctions.find(
              (element) => element.id === 'concatenar_campos'
            );
          concatColumnTransformation.parameters = [];

          this.addCheckInTransformations();
          this.transformationFunctions.sort((a, b) =>
            this.sortByParams(a, b)
          );
          await this.incrementTransformationPattern();
        }
      } catch (error) {
        this.$refs.SnackbarCustomize.open(
          'error',
          'Erro ao carregar as funções de transformação'
        );
      }
    },
    sortByParams(a, b) {
      if (a.isModal > b.isModal) return 1;
      if (a.isModal < b.isModal) return -1;
      return 0;
    },
    addCheckInTransformations() {
      const transformation = this.transformationFunctions.map((element) => ({
        id: element.id,
        name: element.name,
        isChecked: false,
        isModal:
          element.name === 'Depara Avançado' ||
          element.id === 'concatenar_campos' ||
          element.parameters.some((param) => !param.isField),
        parameters: element.parameters,
      }));
      this.transformationFunctions = transformation;
      this.addIsAlphanumericParameter();
    },
    addIsAlphanumericParameter() {
      this.transformationFunctions.forEach((transformation) => {
        if (transformation.isModal) {
          transformation.parameters.forEach((parameter) => {
            parameter.isAlphanumeric = false;
          });
        }
      });
    },
    async incrementTransformationPattern() {
      this.layout.columns.forEach((column, index) => {
        if (column.columnType === 'DEFAULT') {
          this.layout.columns[index].transformations = lodash.cloneDeep(
            this.transformationFunctions
          );
        }
      });
      this.$emit('overlayControll', false);
      if (this.isEdit || this.isCopy || this.isImport) {
        await this.selectLoadedTransformations();
      }
    },
    async checkParameterInTransformation(itemChild, item) {
      await this.checkToken();
      if (itemChild || !itemChild.field) {
        itemChild.field = item.name;
      }
      itemChild.parameters = [];
      itemChild.parameters.push({
        isAlphanumeric: false,
        isField: true,
        order: 1,
        name: item.name,
        value: item.name,
      });
      this.transformationParameter = this.createColumnFunction(
        itemChild,
        item
      );
    },
    async openModalTransformations(itemChild, item) {
      await this.checkToken();

      if (itemChild) {
        this.transformationParameter = this.createColumnFunction(
          itemChild,
          item
        );
        setTimeout(() => {
          this.$emit('scrollComponent', true);
        }, 1000);

        if (this.transformationParameter) {
          switch (this.transformationParameter.template) {
            case 'depara':
              this.openDeparaModal(itemChild, item);
              break;
            case 'depara_avancado':
              this.openAdvancedDeparaModal(item);
              break
            case 'concatenar_campos':
              if (
                item.complementaryLayout !== true &&
                !this.concatFunctionValidation(item)
              ) {
                itemChild.isChecked = false;
                return;
              }
              if (
                item.complementaryLayout === true &&
                !this.concatFunctionValidationComplementary(item)
              ) {
                itemChild.isChecked = false;
                return;
              }
              this.resetOrderTransformations(item);
              this.openConcatColumnModel(item);
              break;
            default:
              this.openDefaultTransformationModal(item);
              break;
          }
        }
      }
    },
    openDeparaModal(itemChild, item) {
      if (!this.isEdit) {
        this.updateItemChildParameters(itemChild, item);
      }
      setTimeout(() => {
        this.$refs.transformationsFromToModal.open(item);
      }, 500);
    },
    openAdvancedDeparaModal(item) {
      setTimeout(() => {
        this.$refs.transformationsFromToAdvancedModal.open(item);
      }, 500);
    },
    openConcatColumnModel(item) {
      setTimeout(() => {
        this.$refs.transformationsConcatColumnModal.open(item);
      }, 500);
    },
    openDefaultTransformationModal(item) {
      setTimeout(() => {
        this.$refs.transformationModal.open(item);
      }, 250);
    },
    updateItemChildParameters(itemChild, item) {
      itemChild.parameters[0].isAlphanumeric = false;
      itemChild.parameters[0].isField = true;
      itemChild.parameters[0].order = 1;
      itemChild.parameters[0].name = item.name;
      itemChild.parameters[0].value = item.name;
    },
    createColumnFunction(itemChild, item) {
      const layoutColumnIndex = this.layout.columns.indexOf(item);
      if (layoutColumnIndex >= 0) {
        const transformationIndex =
          this.layout.columns[layoutColumnIndex].transformations.indexOf(
            itemChild
          );
        if (transformationIndex >= 0) {
          this.layout.columns[layoutColumnIndex].transformations[
            transformationIndex
          ].template = itemChild.template ? itemChild.template : itemChild.id;
          this.layout.columns[layoutColumnIndex].transformations[
            transformationIndex
          ].field = item.name;
          this.layout.columns[layoutColumnIndex].transformations[
            transformationIndex
          ].id = null;
          return this.layout.columns[layoutColumnIndex].transformations[
            transformationIndex
          ];
        }
      }
      return null;
    },
    addColumnFunctionFromModal(data) {
      const layoutColumn = lodash.cloneDeep(this.layout.columns);
      const itemTransformation = layoutColumn
        .find((column) => column.name === data.field)
        .transformations.find(
          (transformation) => transformation.name === data.name
        );
      if (itemTransformation.name === data.name) {
        const columnIndex = layoutColumn.indexOf(
          layoutColumn.find((column) => column.name === data.field)
        );
        if (columnIndex >= 0) {
          itemTransformation.field = data.field;
          itemTransformation.order = data.order;
          itemTransformation.parameters = data.parameters;
          const transformationIndex =
            layoutColumn[columnIndex].transformations.indexOf(
              itemTransformation
            );
          if (transformationIndex >= 0) {
            layoutColumn[columnIndex].transformations[transformationIndex] =
              itemTransformation;
          }
        }
      }
    },
    async selectLoadedTransformations() {
      const layoutSession = JSON.parse(JSON.stringify(this.layoutData));
      this.layout.columns.forEach((column) => {
        if (
          layoutSession &&
          layoutSession.columns &&
          layoutSession.columns.length > 0
        ) {
          const columnSelected = layoutSession.columns.find(
            (columnSession) => columnSession.id === column.id
          );
          if (
            columnSelected &&
            column.transformations &&
            column.transformations.length > 0
          ) {
            column.transformations.forEach((element, index) => {
              const transformationSelected =
                columnSelected.transformations.find(
                  (transformation) => transformation.template === element.id
                );
              if (transformationSelected) {
                const parameterMerge = [];
                this.validateTemplateCalculateDateAndRefactor(
                  transformationSelected,
                  column.transformations,
                  index
                );

                this.mergeParameters(
                  transformationSelected,
                  column.transformations,
                  index,
                  parameterMerge
                );
                column.transformations[index] = {
                  ...column.transformations[index],
                  ...transformationSelected,
                  field: column.name,
                  isChecked: true,
                  parameters:
                    transformationSelected.template !== 'depara' &&
                    transformationSelected.template !== 'depara_avancado' &&
                    transformationSelected.template !== 'concatenar_campos'
                      ? [...parameterMerge]
                      : transformationSelected.parameters,
                };
              }
            });
          }
        }
      });
      this.overlay = false;
    },
    validateTemplateCalculateDateAndRefactor(
      transformationSelected,
      columnTransformations,
      index
    ) {
      if (transformationSelected.template === 'calcula_data') {
        const parametersCalculaData = transformationSelected.parameters[0];
        const checkParameterIsField = columnTransformations[
          index
        ].parameters.filter(
          (param) => param.isField !== null && param.isField
        );
        if (checkParameterIsField.length === 0) {
          columnTransformations[index].parameters.unshift({
            isAlphanumeric: parametersCalculaData.isAlphanumeric,
            isField: true,
            order: 1,
            name: parametersCalculaData.value,
            value: parametersCalculaData.value,
          });
        }
        columnTransformations[index].parameters = columnTransformations[
          index
        ].parameters.map((paramMap, indexMap) => ({
          ...paramMap,
          order: indexMap + 1,
        }));
        transformationSelected.parameters =
          transformationSelected.parameters.map((paramMap, indexMap) => ({
            ...paramMap,
            order: indexMap + 1,
          }));
      }
    },
    concatFunctionValidationComplementary(item) {
      if (item.name === 'Sem Referência' || item.name === 'no_reference')
        return true;
      this.$refs.SnackbarCustomize.open(
        'error',
        'A função Concatenar Campos só pode ser utilizada em colunas do tipo Sem Referência.',
        10000
      );
      return false;
    },
    concatFunctionValidationComplementaryBtn(itemChild, item) {
      const templateField = itemChild.template
        ? itemChild.template
        : itemChild.id;
      return (
        templateField === 'concatenar_campos' &&
        !['Sem Referência', 'no_reference'].includes(item.name)
      );
    },
    concatFunctionValidation(item) {
      if (
        this.layout.typeIntegrationValue === 'SHIPPING' &&
        item.fromTo === 'no_reference' &&
        this.layout.insuranceCarrierId
      )
        return true;
      this.$refs.SnackbarCustomize.open(
        'error',
        'A função Concatenar Campos só pode ser utilizada em colunas do tipo Sem Referência.',
        10000
      );
      return false;
    },
    concatFunctionValidationBtn(itemChild) {
      const templateField = itemChild.template
        ? itemChild.template
        : itemChild.id;
      return (
        templateField === 'concatenar_campos' &&
        this.layout.typeIntegrationValue !== 'SHIPPING'
      );
    },
    mergeParameters(transformationSelected, columnTransformations, index, parameterMerge) {
      columnTransformations[index].parameters.forEach((parameter, i) => {
        if (
          transformationSelected.template !== 'depara' &&
          transformationSelected.template !== 'depara_avancado' &&
          transformationSelected.template !== 'concatenar_campos'
        ) {
          const parameterSelected = transformationSelected.parameters.find(
            (parameterFind) => parameterFind.order === parameter.order
          );
          if (parameterSelected) {
            parameterMerge.push({
              ...columnTransformations[index].parameters[i],
              ...parameterSelected,
            });
          }
        }
      });
    },
    isToDisableCheck(itemChild, item) {
      const isEqualFixedValue = item.transformations.find(
        (transformation) => transformation.template === 'valor_fixo'
      );
      const isDifferentFixedValue = item.transformations.find(
        (transformation) => transformation.template !== 'valor_fixo'
      );
      return (
        (itemChild.template !== 'valor_fixo' &&
          isEqualFixedValue &&
          isEqualFixedValue.isChecked) ||
        (itemChild.template === 'valor_fixo' &&
          isDifferentFixedValue &&
          isDifferentFixedValue.isChecked)
      );
    },
    async checkToken() {
      const tokenActive =
        sessionStorage.getItem(this.SESSION_STORAGE_TOKEN) ||
        sessionStorage.getItem(this.SESSION_ODOO_TOKEN) ||
        '';
      const shouldRefreshToken = hasEffectiveBearerToken(tokenActive)
        && this.rule.checkExpiredToken(tokenActive);
      if (shouldRefreshToken) {
        await this.refreshToken();
      }
    },
    async refreshToken() {
      const TOKEN_PREFIX = 'Bearer ';
      observableMutationsRefreshToken.setLoadingRefreshToken(true);
      try {
        const response = await this.authService.GetTokenFullByRefresh();
        if (response && response.data) {
          const { token } = response.data;
          const fullToken = `${TOKEN_PREFIX}${token}`;
          sessionStorage.setItem(this.SESSION_STORAGE_TOKEN, fullToken);
          sessionStorage.setItem(this.SESSION_ODOO_TOKEN, fullToken);
          await this.loadUserSessionData();
        }
      } catch (error) {
        console.error('Error refreshing tokens:', error);
      } finally {
        observableMutationsRefreshToken.setLoadingRefreshToken(false);
      }
    },
    async loadUserSessionData() {
      this.userService = new UserService();
      await this.userService
        .GetCurrent()
        .then((response) => {
          const session = response.data;
          if (session) {
            const userSessionStorage = {
              authorities: session.authorities,
              user: {
                id:
                  session.id
                    ? session.id
                    : null,
                name:
                  session.account && session.account.name
                    ? session.account.name
                    : null,
                email:
                  session.account && session.account.email
                    ? session.account.email
                    : null,
              },
            };
            this.userUtils.createUserSessionStorage(userSessionStorage);
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.status === 401) {
            this.$refs.SnackbarCustomize.open('error', 'Token inexistente');
          }
        });
    },
    /*
    reorder the order of transformations when the "Concatenar os Campos"
    option is selected, leaving "Concatenar os Campos" first.
  */
    resetOrderTransformations(item) {
      const columnIndex = this.layout.columns.findIndex(
        (el) => el.id === item.id
      );

      let columns = this.layout.columns;
      let transformations = columns[columnIndex].transformations;

      const concatFunctionIndex = transformations.findIndex(
        (el) => el.template === 'concatenar_campos'
      );
      if (concatFunctionIndex === -1) return;
      this.rearrangeTransformations(
        transformations,
        columnIndex,
        concatFunctionIndex
      );
    },
    /*
    defines list of transformations with defined order
  */
    setTransformationsWithOrder(columnIndex, transformationsOrdered) {
      return this.layout.columns[columnIndex].transformations
        .map((transformation, index) => ({
          order: transformation.order,
          index,
        }))
        .filter(
          (transformation) =>
            transformation.order &&
            !transformationsOrdered.includes(transformation.index)
        )
        .sort((a, b) => a.order - b.order);
    },
    // performs the reordering
    rearrangeTransformations(
      transformations,
      columnIndex,
      concatFunctionIndex
    ) {
      let count = 1;
      let transformationsOrdened = [concatFunctionIndex];
      transformations[concatFunctionIndex].order = 1;
      this.$forceUpdate();

      while (count !== false) {
        let transformationOrders = this.setTransformationsWithOrder(
          columnIndex,
          transformationsOrdened
        );
        const transformationOrder = transformationOrders.find(
          (el) => el.order === count.toString()
        );

        if (Boolean(transformationOrder)) {
          transformations[transformationOrder.index].order = `${count + 1}`;
          transformationOrders = this.setTransformationsWithOrder(
            columnIndex,
            transformationsOrdened
          );
          if (
            !this.checkTransformationsWithSameValue(
              transformationOrders,
              count,
              transformationsOrdened
            )
          ) {
            transformationsOrdened.push(transformationOrder.index);
            count = count + 1;
          }
        } else {
          count = false;
        }
      }
    },
    // check if there are still any orders with the same value
    checkTransformationsWithSameValue(
      transformationOrders,
      count,
      transformationsOrdened
    ) {
      return transformationOrders.some(
        (el) =>
          el.order === `${count}` &&
          transformationsOrdened.every((item) => item !== el.index)
      );
    },
  },

  created() {
    this.rule = new Rules();
    this.functionService = new FunctionService();
    this.dataSourceService = new DataSourceService();
    this.authService = new AuthService();
    this.userUtils = new UserUtils();
    this.formatter = new Formatters();
  },
};
</script>

<style scoped>
  .isSelectedTransformation {
    background-color: color-mix(in srgb, var(--v-error-base), transparent 15%) !important;
    color: var(--v-error-base) !important;
  }

  .backgroundHeaderTransformation {
    background-color: var(--v-muted-foreground-base) !important;
    text-align: center !important;
  }

  .transformationDataTable >>> tbody > tr {
    height: 60px;

  }
</style>
